/**
 * Cache for dashboard data prefetched right after login.
 * Login starts the requests; Dashboard consumes and clears the cache.
 */
import type { DatabaseStats, MajorGamesBenchmarkPayload } from './types';

export interface DashboardPrefetchResult {
  stats: DatabaseStats | null;
  majorGamesBenchmarks: MajorGamesBenchmarkPayload | null;
}

let prefetchPromise: Promise<DashboardPrefetchResult> | null = null;

export function setDashboardPrefetchPromise(p: Promise<DashboardPrefetchResult>) {
  prefetchPromise = p;
}

export function consumeDashboardPrefetch(): Promise<DashboardPrefetchResult> | null {
  const p = prefetchPromise;
  prefetchPromise = null;
  return p;
}
